import axiosSetup from "../utils/axiosSetup";

export type ReplacementReferenceType = "salesRep" | "user" | "customer";

export interface ProductReplacementReference {
  _id: string;
  name?: string;
  customerName?: string;
  username?: string;
  role?: string;
  mobileNumber?: string;
}

export interface ProductReplacementReferencesResponse {
  data: ProductReplacementReference[];
  pagination: {
    totalPages: number;
    totalCount: number;
    page: number;
    limit: number;
  };
}

export type ProductReplacementPayload =
  | {
      serialNumberToReplace: string;
      replacementSerialNumber: string;
      reason: string;
      salesRepId: string;
    }
  | {
      serialNumberToReplace: string;
      replacementSerialNumber: string;
      reason: string;
      userId: string;
    }
  | {
      serialNumberToReplace: string;
      replacementSerialNumber: string;
      reason: string;
      customerRegistrationId: string;
    };

const replacementReferenceEndpoints: Record<ReplacementReferenceType, string> = {
  salesRep: "/dispatch/replacement/references/sales-reps",
  user: "/dispatch/replacement/references/users",
  customer: "/dispatch/replacement/references/customers",
};

export const fetchProductReplacementReferencesApi = async (
  type: ReplacementReferenceType,
  params: { search: string; page: number; limit: number },
): Promise<ProductReplacementReferencesResponse> => {
  const response = await axiosSetup.get(replacementReferenceEndpoints[type], {
    params,
  });
  return response.data;
};

export const replaceDispatchedProductApi = async (
  payload: ProductReplacementPayload,
) => {
  const response = await axiosSetup.post("/dispatch/replacement", payload);
  return response.data.data;
};
